module.exports = __webpack_public_path__ + "img/fetcemg.cfabd3f6.png";